import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import About from "../components/About"
import Address from "../components/Address"
import AboutServices from "../components/AboutServices"

export default function about() {
  return (
    <Layout>
      <SEO
        title="Advogados Especialistas em Direito Criminal"
        lang="en"
        description="Escritório de Advocacia Especializada em Direito Criminal.Lei Maria da Penha.Habeas Corpus.Garanta seus Direitos!Advogado Criminal em Goiânia-Go"
      />
      <About />
      <AboutServices />
      <Address />
    </Layout>
  )
}
